import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"width":"500"},model:{value:(_vm.dialogProp),callback:function ($$v) {_vm.dialogProp=$$v},expression:"dialogProp"}},[_c(VCard,[_c(VToolbar,{attrs:{"flat":""}},[_c(VSpacer),_c(VBtn,{attrs:{"icon":""},on:{"click":function($event){_vm.dialogProp = false}}},[_c(VIcon,[_vm._v(_vm._s(_vm.mdiClose))])],1)],1),_c(VCardTitle,[_c('h4',{staticStyle:{"word-break":"break-word"}},[_vm._v(" In-Patient Care (Confinement/Hospitalization): ")])]),_c(VDivider),_c(VCardText,_vm._l((_vm.descs),function(desc,i){return _c('ul',{key:i},[_c('li',[_vm._v(_vm._s(desc))])])}),0)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }